import React from "react";
import { Card, CardContent, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";

export interface KpiItem {
	label: string;
	value: string;
	detail?: string;
	color: string;
}

interface KpiRowProps {
	items: KpiItem[];
}

const KpiRow: React.FC<KpiRowProps> = ({ items }) => (
	<Grid container spacing={3}>
		{items.map(item => (
			<Grid size={{ xs: 12, sm: 6, md: 3 }} key={item.label}>
				<Card
					sx={{
						height: "100%",
						background: `linear-gradient(135deg, ${item.color}15 0%, ${item.color}05 100%)`,
						border: `1px solid ${item.color}30`,
						borderRadius: 3
					}}
				>
					<CardContent sx={{ p: 3 }}>
						<Typography variant="body2" color="text.secondary" fontWeight={500}>
							{item.label}
						</Typography>
						<Typography variant="h3" fontWeight={700} sx={{ color: item.color, mt: 1 }}>
							{item.value}
						</Typography>
						{item.detail && (
							<Typography variant="caption" color="text.secondary">
								{item.detail}
							</Typography>
						)}
					</CardContent>
				</Card>
			</Grid>
		))}
	</Grid>
);

export default KpiRow;
